import { useEffect, useRef, useState } from "react";
import Overlay from "../common/overlays/Overlay";

const Help: React.FC = () => {
  const [showWhatsNew, setShowWhatsNew] = useState<boolean>(false);

  const okButtonRef = useRef<HTMLButtonElement>(null);

  const releases = [
    {
      version: "1.6.3",
      features: [
        {
          title: "Map Layers Icons",
        },
        {
          title: "Map Layers Reordering",
        },
        {
          title: "Fixes and Improvements",
        },
      ],
    },
    {
      version: "1.6.2",
      features: [
        {
          title: "Map XYZ Tiles Geospatial Layers",
        },
        {
          title: "Map XYZ Tiles Geospatial Layers Sharing",
        },
        {
          title: "Map Current Road Layer Show / Hide",
        },
        {
          title: "ROW to Pavement Camera Image Offset",
        },
        {
          title: "Fixes and Improvements",
        },
      ],
    },
    {
      version: "1.6.1",
      features: [
        {
          title: "New Playback Controls Design",
        },
        {
          title: "Playback Controls in Panoramic Camera when in Full Screen",
        },
        {
          title: "Playback Controls in Pavement Camera when in Full Screen",
        },
        {
          title: "Fixes and Improvements",
        },
      ],
    },
    {
      version: "1.6.0",
      features: [
        {
          title: "Detailed Charts",
        },
        {
          title: "Detailed Charts Editor",
        },
        {
          title: "Detailed Charts Multiple Series and Types",
        },
        {
          title: "Detailed Charts Zoom and Pan",
        },
        {
          title: "Detailed Charts Navigation",
        },
        {
          title: "Detailed Charts Filtering by Table Filters",
        },
        {
          title: "Detailed Charts Sharing",
        },
        {
          title: "Save Last Location",
        },
        {
          title: "Keep Current Location when Switching Years",
        },
        {
          title: "Fixes and Improvements",
        },
      ],
    },
    {
      version: "1.5.1",
      features: [
        {
          title: "Thematic Maps Filtering by Table Filters",
        },
        {
          title: "Pavement Images Playback Improvements",
        },
        {
          title: "General Playback Improvements",
        },
        {
          title: "Fixes and Improvements",
        },
      ],
    },
    {
      version: "1.5.0",
      features: [
        {
          title: "New Table Design",
        },
        {
          title: "Table Sorting and Filtering",
        },
        {
          title: "Table Clear All Filters",
        },

        {
          title:
            "Table Filtered Records Number vs. Total Records Number Visualization",
        },

        {
          title: "Composed Table Filters Text Visualization",
        },
      ],
    },
    {
      version: "1.4.0",
      features: [
        {
          title: "Summary Charts",
        },
        {
          title: "Thematic Maps Filtering by Summary Charts",
        },
        {
          title: "Thematic Maps Legend Improvements",
        },
        {
          title: "Thematic Maps Road Color Ranges view though Current Road",
        },
        {
          title: "Progressive Image Loading on Cameras",
        },
        {
          title: "Fixes and Improvements",
        },
      ],
    },
    {
      version: "1.3.1",
      features: [
        {
          title: "Full Resolution Image Loading for Panoramic Camera",
        },
        {
          title: "Range Image Display on Pavement Camera",
        },
        {
          title: "Pavement Range Image Downloads in Image Downloads",
        },
        {
          title:
            "Thematic Maps Segment Info and Highlight on Hover Over Map Segments",
        },
        {
          title:
            "Thematic Maps Click to go to Location only for Visible Layer Roads",
        },
        {
          title: "Lane Markings Display on Pavement Camera",
        },
        {
          title: "Tooltips on Cameras and Map buttons",
        },
        {
          title: "Map Drag Grab Icon",
        },
        {
          title: "Fixes and Improvements",
        },
        // {
        //   title: "Connect to Inform Publishing",
        // },
      ],
    },
    {
      version: "1.3.0",
      features: [
        {
          title: "Thematic Maps",
        },
        {
          title: "Distress Display on Pavement Camera",
        },
      ],
    },
    {
      version: "1.2.2",
      features: [
        {
          title: "Share Location using GPS and using Network Mapped Fields",
        },
        {
          title: "URL Initialization using GPS and using Network Mapped Fields",
        },
        {
          title:
            "Resizing of smaller Camera Images to fit more container white space",
        },
        {
          title: "Help Menu",
        },
        {
          title: "Save Last used Year for Multi-Year Projects",
        },
        {
          title: "Full Resolution Image Loading for Normal Cameras",
        },
      ],
    },
    {
      version: "1.2.1",
      features: [
        {
          title: "Fixes and Improvements",
        },
      ],
    },
    {
      version: "1.2.0",
      features: [
        {
          title: "Zoom and Pan on Pavement Camera",
        },
        {
          title: "Full Screen Pavement Camera",
        },
        {
          title: "Full Resolution Image Loading for Pavement Camera",
        },
        {
          title:
            "Full Resolution Image Loading for Panoramic Camera when in Full Screen",
        },
      ],
    },
  ];

  useEffect(() => {
    okButtonRef.current?.click();
  }, []);

  const onWhatsNewClicked = () => {
    setShowWhatsNew(true);
  };

  const onWhatsNewCloseClicked = () => {
    setShowWhatsNew(false);
  };

  return (
    <>
      <ul className="dropdown">
        <li>
          <span onClick={onWhatsNewClicked}>What's New</span>
        </li>
        <li>
          <a
            className="link"
            href="https://icc-ims.com/our-software/inform"
            target="_blank"
            rel="noreferrer"
          >
            About Inform
          </a>
        </li>
        <li>
          <a
            className="link"
            href="https://icc-ims.com/our-software"
            target="_blank"
            rel="noreferrer"
          >
            Unify
          </a>
        </li>
        <li>
          <a
            className="link"
            href="https://icc-ims.com/support"
            target="_blank"
            rel="noreferrer"
          >
            Support
          </a>
        </li>
        <li>
          <a
            className="link"
            href="https://icc-ims.com/company/contact-us"
            target="_blank"
            rel="noreferrer"
          >
            Contact us
          </a>
        </li>
      </ul>
      {showWhatsNew && (
        <Overlay>
          <div
            className="box-shadow d-flex flex-column"
            style={{ padding: "40px", borderRadius: "11px" }}
          >
            <div
              className="mb-5"
              style={{
                fontSize: "32px",
                fontWeight: "700",
                textAlign: "center",
              }}
            >
              What's New
            </div>
            <div
              style={{
                height: "600px",
                overflow: "auto",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            >
              {releases.map((release, index1) => (
                <div key={index1.toString()} className="mb-3">
                  <div
                    className="mb-2"
                    style={{ fontSize: "19px", fontWeight: "600" }}
                  >
                    {release.version}
                  </div>
                  {release.features.map((feature, index2) => (
                    <div
                      key={release.version + "_" + index2.toString()}
                      className="mb-1"
                      style={{ fontSize: "17px", fontWeight: "400" }}
                    >
                      {feature.title}
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <div className="mx-auto mt-4">
              <button
                type="button"
                className="btn btn-primary"
                style={{ width: "250px" }}
                onClick={onWhatsNewCloseClicked}
                ref={okButtonRef}
              >
                OK
              </button>
            </div>
          </div>
        </Overlay>
      )}
    </>
  );
};

export default Help;
